import { stringToHash } from 'utils/helpers'
import { CardPosterBackgroundCoverSC } from '../base-card'

/**
 * Channel title without a redundant leading number (UI-5.1-5.3, FP-4301): the
 * card already shows `channelNumber` in its own corner label, so a title built
 * from `"${channelNumber}. ${name}"` would duplicate it in the centered line.
 */
export const stripChannelNumberPrefix = (
  title: string,
  channelNumber?: number
): string => {
  if (channelNumber == null) return title
  const prefix = `${channelNumber}. `
  return title.startsWith(prefix) ? title.slice(prefix.length) : title
}

export const useTvCardBackroundCover = (
  title: string,
  covers?: Record<string, any>
) => {
  if (!covers) return

  const getPoster = (title: string, listLength: number) => {
    const subCategoryNameHash = stringToHash(title)
    const itemNumber = Math.abs(subCategoryNameHash) % listLength
    const item =
      itemNumber > 0
        ? itemNumber <= listLength + 1
          ? itemNumber
          : listLength + 1
        : 1
    return `Cover${item}`
  }
  const img = getPoster(title, Object.keys(covers).length)

  return (
    <CardPosterBackgroundCoverSC>
      <img src={covers[img]} />
    </CardPosterBackgroundCoverSC>
  )
}
